export default "__VITE_ASSET__BQGwOcTr__"